<script setup>
import { ref, onUpdated, defineProps, defineEmits } from "vue"
import useOperators from "../../use/useOperators"
import usePersianTools from "../../use/usePersianTools"

const props = defineProps({
  operator: {
    required: true,
    type: Object,
  },
})

const operatorData = ref({
  id: props.operator.id,
  first_name: props.operator.name,
  last_name: props.operator.surname,
  phone_number: props.operator.phone,
  email: props.operator.email,
  password: "",
  password_confirmation: "",
  status: props.operator.status,
})

const { show, loading, errors, onSubmit, closeModal } = useOperators(
  props,
  emit,
  operatorData
)

const { convertPersianToEnglish } = usePersianTools()

const emit = defineEmits(["update:modelValue", "close"])

onUpdated(() => {
  operatorData.value = {
    id: props.operator.id,
    first_name: props.operator.name,
    last_name: props.operator.surname,
    phone_number: props.operator.phone,
    email: props.operator.email,
    password: "",
    password_confirmation: "",
    status: props.operator.status,
  }
})
</script>

<template>
  <!-- add and edit operator modal  -->
  <b-modal
    v-model="show"
    @close="closeModal()"
    id="showModal"
    hide-footer
    title=" افزودن اپراتور"
    header-class="p-3 bg-light"
    class="v-modal-custom"
    centered
    no-close-on-backdrop
  >
    <b-overlay
      variant="white"
      opacity="0.75"
      blur="2px"
      :show="loading"
      spinner-variant="success"
      rounded="sm"
    >
      <b-card>
        <b-form
          id="addform"
          class="tablelist-form"
          autocomplete="off"
          @submit.prevent="onSubmit"
        >
          <div class="mb-3">
            <label for="operatorfirstname" class="form-label"> نام</label>
            <input
              type="text"
              id="operatorfirstname"
              class="form-control"
              placeholder="نام اپراتور"
              v-model="operatorData.first_name"
            />
            <div v-if="errors">
              <div class="invalid-feedback" v-if="errors.first_name">
                <span>{{ errors.first_name[0] }}</span>
              </div>
            </div>
          </div>

          <div class="mb-3">
            <label for="operatorlastname" class="form-label"
              >نام خانوادگی</label
            >
            <input
              type="text"
              id="operatorlastname"
              class="form-control"
              placeholder="نام خانوادگی اپراتور"
              v-model="operatorData.last_name"
            />
            <div v-if="errors">
              <div class="invalid-feedback" v-if="errors.last_name">
                <span>{{ errors.last_name[0] }}</span>
              </div>
            </div>
          </div>

          <div class="mb-3">
            <label for="email" class="form-label">ایمیل</label>
            <input
              type="email"
              id="email"
              class="form-control"
              placeholder="آدرس ایمیل اپراتور"
              v-model="operatorData.email"
            />
            <div v-if="errors">
              <div class="invalid-feedback" v-if="errors.email">
                <span>{{ errors.email[0] }}</span>
              </div>
            </div>
          </div>

          <div class="mb-3">
            <label for="phone" class="form-label">تلفن</label>
            <input
              type="tel"
              id="phone"
              class="form-control"
              placeholder="شماره تلفن اپراتور"
              v-model="operatorData.phone_number"
              @input="
                convertPersianToEnglish(
                  $event.target.value,
                  operatorData,
                  'phone_number'
                )
              "
            />
            <div v-if="errors">
              <div class="invalid-feedback" v-if="errors.phone_number">
                <span>{{ errors.phone_number[0] }}</span>
              </div>
            </div>
          </div>

          <div class="mb-3">
            <label for="password" class="form-label">کلمه عبور</label>
            <input
              type="password"
              id="password"
              class="form-control"
              placeholder="کلمه عبور (پسورد)"
              v-model="operatorData.password"
              @input="
                convertPersianToEnglish(
                  $event.target.value,
                  operatorData,
                  'password'
                )
              "
            />
            <div v-if="errors">
              <div class="invalid-feedback" v-if="errors.password">
                <span>{{ errors.password[0] }}</span>
              </div>
            </div>
          </div>

          <div class="mb-3">
            <label for="confirm-password" class="form-label"
              >تایید کلمه عبور</label
            >
            <input
              type="password"
              id="confirm-password"
              class="form-control"
              placeholder="تایید کلمه عبور (تکرار کلمه عبور)"
              v-model="operatorData.password_confirmation"
              @input="
                convertPersianToEnglish(
                  $event.target.value,
                  operatorData,
                  'password'
                )
              "
            />
          </div>

          <div class="mb-3">
            <label for="status" class="form-label">وضعیت</label>
            <select
              class="form-control"
              data-trigger
              id="statusfield"
              v-model="operatorData.status"
            >
              <option value="">وضعیت</option>
              <option value="0">غیرفعال</option>
              <option value="1">فعال</option>
            </select>
            <div v-if="errors">
              <div class="invalid-feedback" v-if="errors.status">
                <span>{{ errors.status[0] }}</span>
              </div>
            </div>
          </div>

          <div class="hstack gap-2 justify-content-end">
            <b-button
              type="button"
              id="closemodal"
              variant="light"
              @click="closeModal"
            >
              بستن
            </b-button>
            <b-button type="submit" variant="success">افزودن اپراتور</b-button>
          </div>
        </b-form>
      </b-card>
    </b-overlay>
  </b-modal>
</template>
